/* istanbul ignore file */
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { HttpBaseService } from '../../../core';
import { App, EvaluatedFieldsProperties, FormulaPreview, FormulaPreviewParameters, Project, Site, SiteIdentifier } from '../../models';
import { DifferencesObject } from '../logic-services/models';
import { environment } from './../../../environments/environment';

@Injectable({
    providedIn: 'root'
})
export class SiteDataDataService extends HttpBaseService {
    private route = environment.api + 'sitedata/app/';

    constructor(
        private _httpClient: HttpClient,
    ) {
        super(_httpClient);
    }

    updateSiteData(app: App, project: Project, site: Site, data: any): Observable<Site> {
        const url = `${this.route}${app.id}/project/${project.id}/site/${site.id}`;
        return this.httpPost(url, data);
    }

    updateAndRunLogics(app: App, project: Project, site: Site, data: any): Observable<EvaluatedFieldsProperties> {
        const url = `${this.route}${app.id}/project/${project.id}/site/${site.id}/update-and-run-logics`;
        return this.httpPut(url, data);
    }

    patchLogicBuilderTriggerRepositionGrid(app: App, project: Project, site: Site, patch: DifferencesObject): Observable<EvaluatedFieldsProperties> {
        const url = `${this.route}${app.id}/proj/${project.id}/site/${site.id}/patch-logic-builder-trigger-field-reposition-grid`;
        return this.httpPatch(url, patch);
    }

    patchLogicBuilderTriggerField(app: App, project: Project, site: Site, patch: DifferencesObject): Observable<EvaluatedFieldsProperties> {
        const url = `${this.route}${app.id}/proj/${project.id}/site/${site.id}/patch-logic-builder-trigger-field`;
        return this.httpPatch(url, patch);
    }

    removeLogicBuilderTriggerField(app: App, project: Project, site: Site, patch: DifferencesObject): Observable<EvaluatedFieldsProperties> {
        const url = `${this.route}${app.id}/proj/${project.id}/site/${site.id}/remove-logic-builder-trigger-field`;
        return this.httpPatch(url, patch);
    }

    patchField(app: App, project: Project, site: Site, patch: DifferencesObject): Observable<Site> {
        const url = `${this.route}${app.id}/proj/${project.id}/site/${site.id}/patch-field`;
        return this.httpPatch(url, patch);
    }

    patchFormulaOperandField(app: App, project: Project, site: Site, patch: DifferencesObject): Observable<Site> {
        const url = `${this.route}${app.id}/proj/${project.id}/site/${site.id}/patch-formula-operand-field`;
        return this.httpPatch(url, patch);
    }

    patchReportsFormulaOperandField(app: App, project: Project, site: Site, patch: DifferencesObject): Observable<EvaluatedFieldsProperties> {
        const url = `${this.route}${app.id}/proj/${project.id}/site/${site.id}/report/patch-formula-operand-field`;
        return this.httpPatch(url, patch);
    }

    removeField(app: App, project: Project, site: Site, patch: DifferencesObject): Observable<Site> {
        const url = `${this.route}${app.id}/proj/${project.id}/site/${site.id}/remove-field`;
        return this.httpPatch(url, patch);
    }

    removeFormulaOperandField(app: App, project: Project, site: Site, patch: DifferencesObject): Observable<Site> {
        const url = `${this.route}${app.id}/proj/${project.id}/site/${site.id}/remove-formula-operand-field`;
        return this.httpPatch(url, patch);
    }

    removeReportsFormulaOperandField(app: App, project: Project, site: Site, patch: DifferencesObject): Observable<EvaluatedFieldsProperties> {
        const url = `${this.route}${app.id}/proj/${project.id}/site/${site.id}/report/remove-formula-operand-field`;
        return this.httpPatch(url, patch);
    }

    getSingleSiteEvaluatedFieldsProperties(app: App, project: Project, site: Site): Observable<EvaluatedFieldsProperties> {
        const url = `${this.route}${app.id}/proj/${project.id}/site/${site.id}/evaluate-logic`;
        return this.httpGet(url);
    }

    getSummaryProjectSiteEvaluatedFieldsProperties(app: App, project: Project, site: Site): Observable<EvaluatedFieldsProperties> {
        const url = `${environment.api}sitedata/apps/${app.id}/summary-projects/${project.id}/sites/${site.id}/evaluate-logic`;
        return this.httpGet(url);
    }

    getSingleSiteEvaluatedFormulaFields(app: App, project: Project, site: Site): Observable<EvaluatedFieldsProperties> {
        const url = `${this.route}${app.id}/proj/${project.id}/site/${site.id}/evaluate-formula-fields`;
        return this.httpGet(url);
    }

    getSummaryProjectSiteEvaluatedFormulaFields(app: App, project: Project, site: Site): Observable<EvaluatedFieldsProperties> {
        const url = `${environment.api}sitedata/apps/${app.id}/summary-projects/${project.id}/sites/${site.id}/evaluate-formula-fields`;
        return this.httpGet(url);
    }

    getSitesWithPointCategory(app: App, project: Project, categoryId: string): Observable<SiteIdentifier[]> {
        const url = `${this.route}${app.id}/proj/${project.id}/category/${categoryId}/get-sites-with-point-category`;
        return this.httpGet(url);
    }

    getFormulaPreviewValues(formulaPreview: FormulaPreviewParameters): Observable<FormulaPreview> {
        const url = `${this.route}${formulaPreview.appId}/proj/${formulaPreview.projectId}/formula-preview`;
        return this.httpPost(url, formulaPreview);
    }
}
